export type CustomInspirationPhoto = { dataUrl: string; name: string; width: number; height: number }
export const MAX_INSPIRATION_DATA_LENGTH = 600000

/** Only bounded raster data prepared by the upload control can be embedded. */
export function customInspirationPhoto(value: any): CustomInspirationPhoto | null {
  if (!value || typeof value.dataUrl !== 'string' || value.dataUrl.length > MAX_INSPIRATION_DATA_LENGTH || !/^data:image\/jpeg;base64,\/9j\/[A-Za-z0-9+/]*={0,2}$/.test(value.dataUrl)) return null
  if (![value.width, value.height].every(n => Number.isInteger(n) && n > 0 && n <= 1600)) return null
  return { dataUrl: value.dataUrl, name: typeof value.name === 'string' ? value.name.slice(0, 120) : 'Inspiration photo', width: value.width, height: value.height }
}
